// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member.page.title': 'Team Members',
    'team-member.page.archive.title': 'Archived Team Members',
    'team-member.page.search_results': 'Search Results',
    'team-member.page.create.title': 'Create New Team Member',
    'team-member.page.search.title': 'Find Team Members',
    'team-member.page.edit.title': 'Edit Team Member',
    'team-member.page.view.title': 'Team Member',
    'team-member.page.all': 'All',

    'team-member.tab.label.profile': 'Profile',
    'team-member.tab.label.files': 'Files',
    'team-member.tab.label.assets': 'Assets',
    'team-member.tab.label.emergency_contacts': 'Emergency',
    'team-member.tab.label.memos': 'Memos',
    'team-member.tab.label.payslips': 'Payslips',
    'team-member.tab.label.employment_history': 'Employment',
    'team-member.tab.label.attendance': 'Attendance',
    'team-member.tab.label.payroll_adjustments': 'Payroll Adjustments',
    'team-member.tab.label.salary_packages': 'Salary Packages',
    'team-member.tab.label.time_sheet': 'Time Sheet',
    'team-member.tab.label.settings': 'Settings',
    'team-member.tab.label.payment_detail': 'Payment Details',

    'team-member.button.cancel': 'Cancel',
    'team-member.button.select': 'Select',
    'team-member.button.find': 'Find Team Members',
    'team-member.button.search': 'Apply',
    'team-member.button.create': 'Save Team Member',
    'team-member.button.new': 'New Team Member',
    'team-member.button.save': 'Save Changes',
    'team-member.button.archive': 'Archive',
    'team-member.button.delete': 'Delete',
    'team-member.button.edit': 'Edit',
    'team-member.button.restore': 'Restore',
    'team-member.button.reset': 'Reset',

    'team-member.placeholder.search': 'Search team members',

    'team-member.link.create_first_team_member': 'Click here to create your first team member',
    'team-member.link.team_members': ' Return to Team Members',
    'team-member.link.archive': 'Archived Team Members',
    'team-member.link.retry': 'Click here to retry',

    'team-member.checkbox.all': 'Check All',
    'team-member.checkbox.actions_label': 'with selected',

    'team-member.label.upload': 'Click to upload or drag and drop',
    'team-member.label.upload_types': 'JPG,PNG,JPEG, Max 2MB',
    'team-member.label.jurisdiction_name': 'Jurisdiction',

    'team-member.label.identification': 'Identification',
    'team-member.label.organization_identification_type_name': 'Identification Type',
    'team-member.label.identification_number': 'Identification Number',

    'team-member.label.title': 'Title',
    'team-member.label.name': 'Name',
    'team-member.label.first_name': 'First Name',
    'team-member.label.last_name': 'Last Name',
    'team-member.label.middle_name': 'Middle Name',
    'team-member.label.other_names': 'Other Names',
    'team-member.label.suffix': 'Suffix',
    'team-member.label.alias': 'Alias',
    'team-member.label.gender': 'Gender',
    'team-member.label.team_member_reporting_role_name': 'Reports To',
    'team-member.label.date_of_birth': 'Date Of Birth',

    'team-member.label.address': 'Address',
    'team-member.label.address_line_1': 'Address Line 1',
    'team-member.label.address_line_2': 'Address Line 2',
    'team-member.label.address_line_3': 'Address Line 3',
    'team-member.label.province': 'Province',
    'team-member.label.postal_code': 'Postal Code',
    'team-member.label.country_name': 'Country',
    'team-member.label.email_address': 'Email Address',
    'team-member.label.telephone': 'Telephone',
    'team-member.label.mobile': 'Mobile',
    'team-member.label.team_member_number': 'Team Member Number',
    'team-member.label.joined_on': 'Joined On',

    'team-member.label.organization_position_name': 'Organization Position',
    'team-member.label.payroll_pay_period_name': 'Payroll Pay Period',
    'team-member.label.hours_per_week': 'Hours Per Week',
    'team-member.label.days_per_week': 'Days Per Week',
    'team-member.label.annual_salary': 'Annual Salary',

    'team-member.label.payroll_level_name': 'Payroll Level',
    'team-member.label.payroll_type_name': 'Payroll Type',

    'team-member.label.organization_location_name': 'Organization Location',
    'team-member.label.salary_condition': 'Salary Condition',

    'team-member.label.payroll_expense_general_ledger_account_name': 'Payroll Expense Account',

    'team-member.label.is_first_job': 'Is First Job',

    'team-member.label.team_member_photo': 'Team Member Photo',
    'team-member.label.payroll_currency_name': 'Payroll Currency',
    'team-member.label.username': 'Username',
    'team-member.label.image_description': 'Upload images should be a square, recommended size 300x300',

    'team-member.sort.field_label': 'Field',
    'team-member.sort.direction_label': 'Direction',
    'team-member.sort.direction_ascending': 'Ascending',
    'team-member.sort.direction_descending': 'Descending',

    'team-member.modal.title.team_member_archive': 'Archive Team Member',
    'team-member.modal.title.team_member_photo_delete': 'Delete Photo',
    'team-member.modal.title.team_member_restore': 'Restore Team Member',
    'team-member.modal.title.no_taxes_alert': 'Warning',

    'team-member.modal.message.no_taxes_alert': 'Making this change may have tax implications. Please consult a certified accountant.',
    'team-member.modal.message.team_member_archive': 'Are you sure that you want to move this team member to the archive? | Are you sure that you want to move these team members to the archive?',
    'team-member.modal.message.team_member_photo_delete': 'Are you sure that you want to delete this photo? This action cannot be undone.',
    'team-member.modal.message.team_member_restore': 'Are you sure that you want to restore this team member? | Are you sure that you want to restore these team members?',

    'team-member.success.message.team_member_created': 'Your team member has been created',
    'team-member.success.message.team_member_imported': 'Please check your email for the import status',

    'team-member.success.message.team_member_updated': 'Your team member has been updated',
    'team-member.success.message.team_member_restored': 'Your team member has been restored | All selected team members were restored',
    'team-member.success.message.team_member_photo_deleted': 'The photo has been deleted',
    'team-member.success.message.archived_team_members': 'Your team member was moved to the archive | All selected team members were moved to the archive',

    'team-member.error.message.archived_team_members': 'This team member was already moved to the archive | These team members were already moved to the archive',
    'team-member.error.message.archive_not_allowed_team_members': 'This team member cannot be archived while still employed — only inactive team members can be archived | These team members cannot be archived while still employed — only inactive team members can be archived',
    'team-member.error.message.team_member_photo_deleted': 'This photo was already deleted',
    'team-member.error.message.team_member_restored': 'This team member was already restored | These team members were already restored',
    'team-member.error.message.error_loading_page': 'Sorry, there was an error loading team member.| Sorry, there was an error loading team members.',
    'team-member.error.message.error_importing_team_members': 'Sorry, there was an error uploading your team members. Please check your file and try again.',

    'team-member.message.search.no_archived_team_members': "You haven't archived any team any members as yet.",

    'team-member-csv.page.note': 'Please ensure to click the check mark if your file already includes headers.',
    'team-member-csv.page.required_fields': 'Required Fields',
    'team-member-csv.page.all_fields': 'All Fields',
    'team-member-csv.page.message.column_names': 'Column names are in the first line',
    'team-member-csv.page.message.field': 'Field',
    'team-member-csv.page.message.column': 'Column',

    'team-member-csv.error.message.csv_is_blank': "It looks like the CSV file is empty. No worries — just take a moment to double-check your file, and feel free to try again whenever you're ready!",
    'team-member-csv.page.instructions': 'Below are two sample files which will show the fields used in the import process.',

    'team-member-csv.error.message.invalid_file_type': 'Sorry, we only support CSV files. Please try again with a CSV file.',

    'team-member.success.message.team_member_invited': 'The team member invitation will be sent shortly.',
    'team-member.error.message.invalid_email_address': 'Invalid team member email address',
    'team-member.button.invite': 'Invite To Portal',
};
